import React from 'react';

const Footer = () => {
  return (
    <footer className="relative bg-gradient-to-b from-green-900 via-green-950 to-black py-12 px-4 overflow-hidden border-t border-green-800">
      {/* Subtle Background Glow */}
      <div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-green-500 to-transparent opacity-30"></div>
      
      <div className="max-w-4xl mx-auto flex flex-col items-center relative z-10">
        {/* Logo */}
        <div className="mb-5 relative group">
          <div className="absolute -inset-2 bg-gradient-to-r from-green-400 to-yellow-400 rounded-2xl blur opacity-20 group-hover:opacity-40 transition duration-1000 group-hover:duration-200"></div>
          <img 
            src="/images/logo.jpg" 
            alt="Ad Dawah Logo" 
            className="relative w-24 h-auto mx-auto rounded-xl shadow-2xl border border-white/10"
          />
        </div>

        {/* Company Name */}
        <h2 className="text-white font-extrabold text-2xl mb-1 tracking-wider drop-shadow-md">
          Ad Dawah
        </h2>

        {/* Phone Number Clickable */}
        <a 
          href="tel:+8801814938247" 
          className="text-green-400 text-lg md:text-xl font-bold hover:text-white transition-colors mb-8 tracking-wide drop-shadow-sm"
        >
          +88 01814938247
        </a>

        {/* Premium Metallic WhatsApp Button */}
        <a 
          href="https://wa.me/8801814938247" 
          target="_blank" 
          rel="noopener noreferrer"
          className="relative group w-[95%] sm:w-auto inline-block rounded-full transition-transform duration-300 hover:-translate-y-1 mb-6 shrink-0"
        >
          {/* Base metallic gradient & shadow layer */}
          <div className="absolute inset-0 bg-gradient-to-b from-[#25D366] via-[#1EBE53] to-[#128C38] rounded-full shadow-[0_5px_15px_rgba(37,211,102,0.4)] group-hover:shadow-[0_8px_25px_rgba(37,211,102,0.6)] transition-shadow duration-300"></div>
          
          {/* Metallic Top Glare */}
          <div className="absolute top-0 inset-x-0 h-1/2 bg-gradient-to-b from-white/40 to-transparent rounded-t-full pointer-events-none"></div>
          
          {/* Bottom Reflection */}
          <div className="absolute bottom-0 inset-x-0 h-1/4 bg-gradient-to-t from-black/20 to-transparent rounded-b-full pointer-events-none"></div>

          {/* Animated Shine Effect */}
          <div className="absolute inset-0 overflow-hidden rounded-full">
             <div className="absolute inset-0 -translate-x-[150%] group-hover:translate-x-[150%] transition-transform duration-1000 ease-in-out bg-gradient-to-r from-transparent via-white/50 to-transparent w-full skew-x-[-20deg]"></div>
          </div>

          {/* Button Content */}
          <div className="relative flex items-center justify-center gap-2 py-3 px-4 sm:px-10 border border-white/30 rounded-full flex-nowrap">
            <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 sm:w-6 sm:h-6 fill-white drop-shadow-md shrink-0" viewBox="0 0 24 24">
              <path d="M12.031 6.172c-3.181 0-5.767 2.586-5.768 5.766-.001 1.298.38 2.27 1.019 3.287l-.582 2.128 2.182-.573c.978.58 1.911.928 3.145.929 3.178 0 5.767-2.587 5.768-5.766.001-3.187-2.575-5.77-5.764-5.771zm3.392 8.244c-.144.405-.837.774-1.17.824-.299.045-.677.063-1.092-.069-.252-.08-.575-.187-.988-.365-1.739-.751-2.874-2.502-2.961-2.617-.087-.116-.708-.94-.708-1.793s.448-1.273.607-1.446c.159-.173.346-.217.462-.217l.332.006c.106.005.249-.04.39.298.144.347.491 1.2.534 1.287.043.087.072.188.014.304-.058.116-.087.188-.173.289l-.26.304c-.087.086-.177.18-.076.354.101.174.449.741.964 1.201.662.591 1.221.774 1.394.86s.274.072.376-.043c.101-.116.433-.506.549-.68.116-.173.231-.145.39-.087s1.011.477 1.184.564.289.13.332.202c.045.072.045.418-.097.824z" fillRule="evenodd" clipRule="evenodd"/>
            </svg>
            <span className="text-white font-extrabold text-[15px] sm:text-[17px] tracking-wide drop-shadow-md whitespace-nowrap shrink-0">
              WhatsApp এ যোগাযোগ
            </span>
          </div>
        </a>

        {/* Divider */}
        <div className="w-full max-w-sm border-t border-white/10 my-4"></div>

        {/* Copyright */}
        <p className="text-green-500/80 text-xs sm:text-sm text-center font-medium mt-2">
          &copy; 2026 Ad Dawah — সকল স্বত্ব সংরক্ষিত
        </p>
      </div>
    </footer>
  );
};

export default Footer;
